// src/config.js
let config = {
	REACT_APP_WEB_LINK: '',
	REACT_APP_IMG_UPLOAD_LINK: '',
};

export const loadConfig = async () => {
	const response = await fetch('/config.json');
	const json = await response.json();
	config = json;

	const isLocalhost = window.location.hostname === 'localhost';

	config.REACT_APP_WEB_LINK = config.REACT_APP_WEB_LINK.replace(
		'[host]',
		isLocalhost ? 'https://dev-customer.schedulerdesk.com' : window.location.origin,
	);
	config.REACT_APP_IMG_UPLOAD_LINK = config.REACT_APP_IMG_UPLOAD_LINK.replace(
		'[host]',
		isLocalhost ? 'https://dev-customer.schedulerdesk.com' : window.location.origin,
	);
};

export const getConfig = () => config;
